import React, { useState, useEffect, useReducer } from 'react';
import * as Yup from 'yup';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { toAbsoluteUrl } from '../../../../../../_metronic/_helpers';
import { Select } from '../../../../../../_metronic/_partials/controls';
import Numeric from '../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../redux/my-axios';
import { adjustTypeList } from '../StocksUIHelpers';
import StockItems from './StockItems';
import Divider from './Divider';
import css from './style.module.css';

const URL = '/stocks';

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        id: action.payload.id,
        icon: action.payload.icon,
        adjustType: action.payload.adjustType,
        productCode: action.payload.productCode,
        name: action.payload.name,
        brandName: action.payload.brandName,
        categoryName: action.payload.categoryName,
        productPrice: parseFloat(action.payload.productPrice),
        productCost: parseFloat(action.payload.productCost),
        productCount: action.payload.productCount,
        productWeight: action.payload.productWeight,
        productSubProductsCount: action.payload.productSubProductsCount,
        boxId: action.payload.boxId,
        qty: action.payload.qty,
        rest: action.payload.rest,
        cost: action.payload.cost
          ? parseFloat(action.payload.cost)
          : parseFloat('0'),
        expireDate: action.payload.expireDate,
        note: action.payload.note,
        orderDate: action.payload.orderDate,
        orderCode: action.payload.orderCode,
        trackingId: action.payload.trackingId,
        parentStockId: action.payload.parentStockId,
      };
    case 'setOrderDate':
      return { ...state, orderDate: action.payload };
    case 'setOrderCode':
      return { ...state, orderCode: action.payload };
    case 'setTrackingId':
      return { ...state, trackingId: action.payload };
    case 'setProductCode':
      return { ...state, productCode: action.payload };
    case 'setCost':
      return { ...state, cost: parseFloat(action.payload) };
    case 'setQty':
      return { ...state, qty: Number(action.payload) };
    case 'setRest':
      return { ...state, rest: Number(action.payload) };
    case 'setExpireDate':
      return { ...state, expireDate: action.payload };
    case 'setNote':
      return { ...state, note: action.payload };
    case 'setAdjustType':
      return { ...state, adjustType: action.payload };
    default:
      console.log('Wrong Dispatch: ', action);
  }
}

const StockViewForm = (props) => {
  const {
    intl,
    actionsLoading,
    info,
    error,
    stockForView,
    initialStock,
    btnRefSave,
    newClick,
    btnRefNew,
    saveStock,
    onHide,
  } = props;
  // States
  const [state, dispatch] = useReducer(reducer, initialStock);
  const [err, setErr] = useState();
  const [msg, setMsg] = useState();
  const [loading, setLoading] = useState(actionsLoading);
  const [openDivider, setOpenDivider] = useState(false);

  // Messages
  const MIN_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_LENGTH',
  });
  const MAX_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_LENGTH',
  });
  const REQUIRED = intl.formatMessage({
    id: 'GENERAL.VALIDATION.REQUIRED',
  });
  const StockCreateSchema = Yup.object().shape({
    productCode: Yup.string().required(REQUIRED),
    qty: Yup.string().required(REQUIRED),
  });

  useEffect(() => {
    //console.log('StockForView', stockForView);
    dispatch({ type: 'init', payload: stockForView });
  }, [stockForView]);

  useEffect(() => {
    setMsg('');
    setErr(error);
  }, [error]);
  useEffect(() => {
    setErr('');
    setMsg(info);
  }, [info]);
  useEffect(() => {
    setLoading(actionsLoading);
  }, [actionsLoading]);
  useEffect(() => {
    console.log('StockViewForm.STATE', state);
  }, [state]);

  const save = (values) => {
    console.log('Save:', values);
    saveStock(values);
  };

  const divide = (newQty) => {
    console.log('newQty', newQty);
    setLoading(true);
    axios
      .post(
        URL,
        {
          stockId: state.id,
          newQty: newQty,
        },
        { headers: { action: 'divide' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_INFO':
            setErr('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            newClick();
            break;
          case 'SUCCESS_WITH_WARNING':
            //console.log('set items: ', response.data.data);
            setErr('');
            setMsg(response.data.data);
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setErr(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setErr(error);
        setLoading(false);
      });
  };

  const setOrderDate = (orderDate) => {
    dispatch({ type: 'setOrderDate', payload: orderDate });
  };
  const setOrderCode = (orderCode) => {
    dispatch({ type: 'setOrderCode', payload: orderCode });
  };
  const setTrackingId = (trackingId) => {
    dispatch({ type: 'setTrackingId', payload: trackingId });
  };

  const setProductCode = (productCode) => {
    dispatch({ type: 'setProductCode', payload: productCode });
  };

  const setQty = (qty) => {
    dispatch({ type: 'setQty', payload: qty });
  };
  const setRest = (rest) => {
    dispatch({ type: 'setRest', payload: rest });
  };

  const setCost = (cost) => {
    dispatch({ type: 'setCost', payload: cost });
  };

  const setExpireDate = (expireDate) => {
    dispatch({ type: 'setExpireDate', payload: expireDate });
  };

  const setAdjustType = (adjustType) => {
    dispatch({ type: 'setAdjustType', payload: adjustType });
  };

  const setNote = (note) => {
    dispatch({ type: 'setNote', payload: note });
  };

  const getPic = (productCode, pic) => {
    if (pic)
      return `${baseUrl}/product-image-download?id=${productCode}&file=${pic}`;
    else return toAbsoluteUrl('/media/logos/logo-gc.png');
  };

  const extractStock = () => {
    setRest(0);
  };

  const divideStock = () => {
    setOpenDivider(true);
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={state}
        validationSchema={StockCreateSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ errors, touched }) => (
          <>
            <Form className='form form-label-right' size='sm'>
              {err ? (
                <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{err}</div>
                </div>
              ) : (
                <div></div>
              )}
              {msg ? (
                <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{msg}</div>
                </div>
              ) : (
                <div></div>
              )}
              {openDivider && (
                <Divider
                  rest={state.rest - 1}
                  divide={divide}
                  openDivider={openDivider}
                  setOpenDivider={setOpenDivider}
                />
              )}
              <div className='form-group row'>
                <div className='col-2'>
                  <div className=''>
                    <div className={css.row}>
                      <div
                        style={{
                          border: '3',
                          width: '100%',
                          height: 'auto',
                          borderRadius: '5%',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          className='img-thumbnail'
                          style={{ width: '100%', height: '100%' }}
                          src={getPic(state.productCode, state.icon)}
                        ></img>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-10'>
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label>
                        <Link to={`/products/${state.productCode}/edit`}>
                          <FormattedMessage id='STOCK.LABEL.PRODUCTCODE' />
                        </Link>
                      </label>
                      <Field
                        name='productCode'
                        className='form-control form-control-sm'
                        onBlur={(e) => {
                          setProductCode(e.target.value);
                        }}
                        disabled={state.id}
                      />
                      {errors.productCode && touched.productCode ? (
                        <div>{errors.productCode}</div>
                      ) : null}
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.PRODUCTNAME' />
                      </label>
                      <Field
                        name='name'
                        className='form-control form-control-sm'
                        disabled={true}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='PRODUCT.LABEL.BRAND' />
                      </label>
                      <Field
                        name='brandName'
                        className='form-control form-control-sm'
                        disabled={true}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='PRODUCT.LABEL.CATEGORY' />
                      </label>
                      <Field
                        name='categoryName'
                        className='form-control form-control-sm'
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.PRICE' />
                      </label>
                      <Numeric
                        id='productPrice'
                        name='productPrice'
                        value={state.productPrice}
                        className='form-control form-control-sm'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        disabled={true}
                        decimalSeparator=''
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.AVERAGECOST' />
                      </label>
                      <Numeric
                        id='productCost'
                        name='productCost'
                        value={state.productCost}
                        className='form-control form-control-sm'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        decimalSeparator=''
                        disabled={true}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.TOTALCOUNT' />
                      </label>
                      <Numeric
                        name='productCount'
                        value={state.productCount}
                        className='form-control form-control-sm'
                        negative={false}
                        type='number'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        disabled={true}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.WEIGHT' />
                      </label>
                      <Numeric
                        id='productWeight'
                        name='productWeight'
                        value={state.productWeight}
                        className='form-control form-control-sm'
                        decimalScale='2'
                        fixedDecimalScale={true}
                        defaultValue='0'
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.DETAIL.QTY' />
                      </label>
                      <Numeric
                        name='qty'
                        value={state.qty}
                        onChange={setQty}
                        className='form-control form-control-sm'
                        negative={false}
                        type='number'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        disabled={state.id}
                        decimalSeparator=''
                      />
                    </div>

                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.DETAIL.COST' />
                      </label>
                      <Numeric
                        id='cost'
                        name='cost'
                        value={state.cost}
                        className='form-control form-control-sm'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        decimalSeparator=''
                        onChange={(e) => {
                          setCost(e);
                        }}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.DETAIL.REST' />
                      </label>
                      <Numeric
                        name='rest'
                        value={state.rest}
                        className='form-control form-control-sm'
                        negative={false}
                        type='number'
                        decimalScale='0'
                        fixedDecimalScale={false}
                        defaultValue='0'
                        disabled={true}
                      />
                    </div>
                    {/*                     <div id='expireDate' className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.EXPIREDATE' />
                      </label>
                      <input
                        id='expireDate'
                        type='date'
                        className='form-control form-control-sm'
                        value={state.expireDate}
                        onChange={handleEvent}
                      />
                    </div> */}

                    <div className='col-3'>
                      <label>
                        <FormattedMessage id='STOCK.LABEL.ADJUSTTYPE' />
                      </label>
                      <Select
                        name='adjustType'
                        className='form-control form-control-sm'
                        onChange={(e) => {
                          setAdjustType(e.target.value);
                        }}
                        disabled={true}
                      >
                        {adjustTypeList.map((option) => (
                          <option
                            key={`adjustTypeList${option.code}`}
                            value={option.code}
                          >
                            {option.name}
                          </option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div className='col-12'>
                      <Field
                        name='note'
                        className='form-control form-control-sm'
                        as='textarea'
                        placeholder='Тэмдэглэл'
                        rows='3'
                        onBlur={(e) => {
                          setNote(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className='form-group row'>
                    <div id='orderDate' className='col-3'>
                      <label>
                        <FormattedMessage id='ORDER.LABEL.ORDERDATE' />
                      </label>
                      {/*                       <input
                        id='orderDate'
                        type='date'
                        className='form-control form-control-sm'
                        value={state.orderDate}
                        onChange={setOrderDate}
                        disabled={state.id}
                      /> */}
                      <Field
                        name='orderDate'
                        className='form-control form-control-sm'
                        //onChange={setOrderCode}
                        disabled={state.id}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <Link to={`/orders/${state.orderCode}/edit`}>
                          <FormattedMessage id='STOCK.LABEL.ORDERCODE' />
                        </Link>
                      </label>
                      <Field
                        name='orderCode'
                        className='form-control form-control-sm'
                        onChange={setOrderCode}
                        disabled={state.id}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        <Link to={`/boxes/${state.boxId}/edit`}>
                          <FormattedMessage id='STOCK.LABEL.TRACKINGID' />
                        </Link>
                      </label>
                      <Field
                        name='trackingId'
                        value={state.trackingId}
                        className='form-control form-control-sm'
                        onChange={setTrackingId}
                        disabled={state.id}
                      />
                    </div>
                    <div className='col-3'>
                      <label>
                        {state.parentStockId ? (
                          <Link to={`/stocks/${state.parentStockId}/edit`}>
                            <FormattedMessage id='STOCK.LABEL.PARENTSTOCKID' />
                          </Link>
                        ) : (
                          <FormattedMessage id='STOCK.LABEL.PARENTSTOCKID' />
                        )}
                      </label>
                      <Field
                        name='parentStockId'
                        className='form-control form-control-sm'
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <button
                type='submit'
                style={{ display: 'none' }}
                ref={btnRefSave}
              ></button>
              <button
                type='button'
                onClick={divideStock}
                style={{ display: 'none' }}
                ref={btnRefNew}
              >
                divide
              </button>
              <button
                type='button'
                onClick={onHide}
                style={{ display: 'none' }}
              >
                cancel
              </button>
            </Form>
          </>
        )}
      </Formik>
      {stockForView.id && stockForView.productSubProduct > 0 && (
        <StockItems stock={stockForView} extractStock={extractStock} />
      )}
    </>
  );
};

export default injectIntl(StockViewForm);
